import React, {Fragment, useEffect, useState} from 'react';
import FalconCardHeader from '../common/FalconCardHeader';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as RegistrationService from '../../services/RegistrationService';
import {withRouter} from 'react-router-dom';
import ProfileModal from './ProfileModal';
import RegisterBankDetails from '../register/RegisterBankDetails';
import ReferralsActivityTable from './ReferralsActivityTable';
import _ from 'lodash';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShareLinkComponent from './ShareLinkComponent';
import ReportFilterModule from './ReportFilterModule';
import MetricsModule from './MetricsModule';
import {getLastDayOfTheMonth} from '../../helpers/utils';

const Dashboard = ({match, history}) => {
  const [userDetails, setUserDetails] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [metricsData, setMetricsData] = useState(null);

  async function getList(params) {
    return await RegistrationService.getPartnerDetails(params);
  }
  
  async function getReferralList(params) {
    getList(params).then((details) => {
      if (details && details.data) {
        setUserDetails(details.data);
      }
    });
  }
  
  useEffect(() => {
    const params = {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        getLastDayOfTheMonth()
      )
    };
    getList(params).then((details) => {
      if (details && details.data) {
        setUserDetails(details.data);
      }
    });
  }, []);

  useEffect(() => {
    if (userDetails && !userDetails.profileComplete) {
      setShowProfileModal(true);
    }
  }, [userDetails]);

  async function updateBankDetailsHandler(params) {
    const response = await RegistrationService.updateBankDetails(params);
    console.log('response:', response);
    if (!response.error) {
      setShowProfileModal(false);
    }
  }

  function copyToClipboardHandler() {
    toast('Copied to clipboard');
  }

  async function getMetricsData(params) {
    const response = await RegistrationService.getMetrics(params);
    if (!response.error) {
      setMetricsData(response.data);
    }
  }

  useEffect(() => {
    const params = {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        getLastDayOfTheMonth()
      )
    };
    getMetricsData(params);
  }, []);

  const runReportHandler = (params) => {
    getMetricsData(params);
    getReferralList(params);
  };
  return (
    <Fragment>
      {showProfileModal && (
        <ProfileModal openModal={showProfileModal}>
          <div className="text-center py-3">
            <h3>{'Action Required'}</h3>
            <p>
              {
                'Link your Bank Account, to enjoy the benefits of Aasaan Affiliate'
              }
            </p>
          </div>
          <RegisterBankDetails
            updateBankDetailsHandler={updateBankDetailsHandler}
          />
        </ProfileModal>
      )}
      {userDetails && (
        <>
          <div className="card-deck mt-3">
            <div className="card">
              <div className="card-body p-2">
                <ReportFilterModule
                  runReportHandler={runReportHandler}
                  metricsData={metricsData}
                />
              </div>
            </div>
          </div>
          <div className="card-deck mt-3">
            <div className="card">
              <div className="card-body p-2">
                <div className="d-flex justify-content-between">
                  <div>
                    <h6 className="m-0 p-2">{userDetails.referral_link}</h6>
                  </div>
                  <div className="d-flex">
                    <CopyToClipboard text={userDetails.referral_link}>
                      <button
                        type="button"
                        className="btn btn-sm btn-dark mx-1"
                        onClick={() => {
                          copyToClipboardHandler();
                        }}
                      >
                        {'Copy Link'}
                      </button>
                    </CopyToClipboard>
                    <ShareLinkComponent />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!_.isEmpty(metricsData) && <MetricsModule metrics={metricsData} />}
          <div className="card-deck mt-3">
            <div className="card mb-3">
              <FalconCardHeader title={`Referral History`} light={false} />
              <div className="card-body p-0">
                {!_.isEmpty(userDetails) &&
                !_.isEmpty(userDetails.referral_history) ? (
                  <ReferralsActivityTable
                    activities={userDetails.referral_history}
                  />
                ) : (
                  <p className="text-center">{'Zero records found'}</p>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default withRouter(Dashboard);
